/* eslint-disable @typescript-eslint/camelcase */
export default {
  apiEndpoint: 'https://webapi.beta.passport.transportation.a2z.com',
  oidc_authority: 'https://idp-integ.federate.amazon.com',
  oidc_client_id: 'trans-passport-integ',
};